import { $api } from '../y/api';
import { QRequest, QResponse } from '../y/data-source';
import { YTimeString, YId } from '../y/types';

export type XLogKind = 'api' | 'sck' | 'sup' | 'job' | 'cmd' | 'tsk' | 'int' | 'mss' | 'web';
export type XLogTag = 'auth' | 'cors' | 'error' | 'notify' | 'panic' | 'ping' | 'redirect' | 'serve_page' | 'sensitive' | 'socket' | 'success';

export interface XLogEntry {
    timestamp: YTimeString;
    id: YId;
    kind: XLogKind;
    status: number;
    tags: XLogTag[];
    endpoint: string;
    stack_trace?: string;
    t_delay: number;
    t_process: number;
    t_total: number;
    api_method?: string;
    api_path?: string;
}

export function xLogGet(id: YId) {
    return $api.GET<XLogEntry>(`x/log/${id}`);
}

export function xLogQuery(query: QRequest) {
    return $api.POST<QResponse<XLogEntry>>('x/log/query', query);
}
